export class OptimalDiffParams {
  typeJson: string = 'optimalDiff';
  bottomEdge!: number;
  topEdge!: number;
  depth!: number;
  applyCompetitorPrices!: boolean;
  applyMinProfitabilityLimit!: boolean;


  constructor(bottomEdge: number,
              topEdge: number,
              depth: number,
              applyCompetitorPrices: boolean,
              applyMinProfitabilityLimit: boolean) {

    this.bottomEdge = bottomEdge;
    this.topEdge = topEdge;
    this.depth = depth;
    this.applyCompetitorPrices = applyCompetitorPrices;
    this.applyMinProfitabilityLimit = applyMinProfitabilityLimit;
  }
}
